import { useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useMemo, useState } from 'react'

import { searchFoods } from '@/api/services/nutrition'

const PAGE_SIZE = 20

export function useFoodSearch() {
  const [searchQuery, setSearchQuery] = useState('')
  const [shopFilter, setShopFilter] = useState<string | null>(null)

  const result = useInfiniteQuery({
    queryKey: ['foods', 'search', searchQuery, shopFilter],
    queryFn: ({ pageParam }) => searchFoods(searchQuery, PAGE_SIZE, shopFilter, pageParam),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => (lastPage.has_more ? lastPage.next_offset : undefined),
    enabled: searchQuery.length >= 2,
  })

  const data = useMemo(() => result.data?.pages.flatMap((page) => page.items), [result.data])

  const trigger = useCallback((query: string, shops?: string | null) => {
    const trimmed = query.trim()
    if (trimmed.length >= 2) {
      setSearchQuery(trimmed)
      setShopFilter(shops ?? null)
    }
  }, [])

  return {
    data,
    isLoading: result.isLoading,
    hasNextPage: result.hasNextPage,
    isFetchingNextPage: result.isFetchingNextPage,
    fetchNextPage: result.fetchNextPage,
    trigger,
  }
}
